import React, { createContext, useContext, useEffect } from 'react';

const KeyboardContext = createContext(null);

export const useKeyboard = () => useContext(KeyboardContext);

export const KeyboardShortcutsProvider = ({ children, onNewIdea, onSearch, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // N - New idea (when not in input)
      if (e.key === 'n' && !['INPUT', 'TEXTAREA'].includes(e.target.tagName)) {
        e.preventDefault();
        onNewIdea?.();
      }
      
      // / - Focus search (when not in input)
      if (e.key === '/' && !['INPUT', 'TEXTAREA'].includes(e.target.tagName)) {
        e.preventDefault();
        onSearch?.();
      }
      
      // ESC - Close modals
      if (e.key === 'Escape') {
        onClose?.();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onNewIdea, onSearch, onClose]);

  return children;
};